import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import CardBottomButton from '@shared/components/cardBottomButton'
import { PlayIcon } from '@shared/components/ctIcons'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import ShortsDetail from '@shared/components/video/shortsDetail'
import { Col, Row } from 'react-bootstrap'
import { useQuery } from '@apollo/client'
import { GET_SHORTS } from '@graphql/videos/videos.query'

const VideoList = ({ data }) => {
  const [showModal, setShowModal] = useState(false)
  const [vidNumber, setVidNumber] = useState(-1)

  const openModal = () => {
    setShowModal(true)
  }

  const closeModal = () => {
    setShowModal(false)
  }
  if (!data?.length) return null

  return (
    <div className={`${styles.bodyContainer} position-relative px-3`}>
      <Row className="d-inline-flex w-100 gx-3">
        {data?.map((item, index) => {
          return (
            <Col
              xs={4}
              key={item._id}
              className={styles.sliderItem}
              onClick={() => {
                setVidNumber(index)
                openModal()
              }}>
              <PlayIcon />
              <MyImage
                src={getImgURL(item.aThumbnails[3].sUrl) || getImgURL(item.sThumbnailUrl)}
                alt={item.sTitle}
                blurDataURL={BLUR_DATA_URL_BASE64}
                placeholder="blur"
                height={230}
                width={192}
                layout="responsive"
                sizes="(max-width: 767px) 120px, (max-width: 991px) 180px, (max-width: 1190px) 200px, 240px"
              />
              <div className={styles.titleContainer}>
                <div className={styles.titleBackground} />
                <div className={styles.titleContent}>
                  <p className={styles.title}>{item.sTitle}</p>
                  <p className={styles.duration}>
                    {item.nDurationSeconds > 60 ? Math.round(item.nDurationSeconds / 60) : 1} {item.nDurationSeconds > 60 ? 'Mins' : 'Min'}
                  </p>
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
      {showModal && <ShortsDetail isOpen={showModal} onClose={closeModal} data={data} vidNumber={vidNumber} />}
    </div>
  )
}

VideoList.propTypes = {
  data: PropTypes.array
}

function PopularVideos() {
  const { data: shorts } = useQuery(GET_SHORTS, {
    variables: {
      input: {
        nSkip: 1,
        nLimit: 3,
        bShorts: true
      }
    }
  })

  if (!shorts?.listVideosFront?.aResults?.length) return null

  return (
    <section className={styles.homePopularStoryContainer}>
      <div className={'common-box p-0'}>
        <h3 className={`${styles.h4MarginBtm} h4 p-3 pb-4 mb-0`}>Popular Stories</h3>
        <VideoList data={shorts?.listVideosFront?.aResults || []} />
        <CardBottomButton text={'View more Web Stories'} link="/videos" internalLink />
      </div>
    </section>
  )
}

export default PopularVideos
